// extracted by mini-css-extract-plugin
export default {"content":"AddToSegmentModal_content__tjJk3","body":"AddToSegmentModal_body__IRAlT","segmentsList":"AddToSegmentModal_segmentsList__doID3"};